import {
  Armchair,
  Battery,
  Car,
  Circle,
  Cloud,
  Cog,
  Droplets,
  Filter,
  Fuel,
  Gauge,
  Lightbulb,
  Navigation,
  Package,
  Radar,
  Radio,
  Settings2,
  Shield,
  Sofa,
  ThermometerSnowflake,
  Volume2,
  Wind,
  Zap,
  Disc3,
  MoveVertical,
} from 'lucide-react';

/**
 * Buyer-facing catalog sub-systems (24). Maps display labels to backend `subSystem` values.
 * Multiple buyer labels may resolve to the same backend bucket for broader coverage.
 */
export const BUYER_SUB_SYSTEMS = [
  { slug: 'braking', label: 'Braking', icon: Disc3, backendKeys: ['Brakes'] },
  { slug: 'cooling', label: 'Cooling', icon: ThermometerSnowflake, backendKeys: ['Cooling'] },
  { slug: 'electrical', label: 'Electrical', icon: Zap, backendKeys: ['Electrical'] },
  { slug: 'suspension', label: 'Suspension', icon: MoveVertical, backendKeys: ['Suspension'] },
  { slug: 'hvac', label: 'HVAC', icon: Wind, backendKeys: ['HVAC'] },
  { slug: 'engine', label: 'Engine', icon: Cog, backendKeys: ['Engine'] },
  { slug: 'transmission', label: 'Transmission', icon: Settings2, backendKeys: ['Transmission', 'Clutch'] },
  { slug: 'body', label: 'Body', icon: Car, backendKeys: ['Body'] },
  { slug: 'interior', label: 'Interior', icon: Armchair, backendKeys: ['Interior'] },
  { slug: 'tyres', label: 'Tyres', icon: Circle, backendKeys: ['Wheels & Tires'] },
  { slug: 'exhaust', label: 'Exhaust', icon: Cloud, backendKeys: ['Exhaust', 'Emissions'] },
  { slug: 'fuel-system', label: 'Fuel System', icon: Fuel, backendKeys: ['Fuel System'] },
  { slug: 'steering', label: 'Steering', icon: Navigation, backendKeys: ['Steering'] },
  { slug: 'lighting', label: 'Lighting', icon: Lightbulb, backendKeys: ['Lighting', 'Ignition'] },
  { slug: 'seating', label: 'Seating', icon: Sofa, backendKeys: ['Interior', 'Accessory'] },
  { slug: 'safety', label: 'Safety', icon: Shield, backendKeys: ['Safety'] },
  { slug: 'sensors', label: 'Sensors', icon: Radio, backendKeys: ['Electrical'] },
  { slug: 'filters', label: 'Filters', icon: Filter, backendKeys: ['Filters'] },
  { slug: 'fluids', label: 'Fluids', icon: Droplets, backendKeys: ['Fluids'] },
  { slug: 'audio', label: 'Audio', icon: Volume2, backendKeys: ['Infotainment'] },
  { slug: 'adas', label: 'ADAS', icon: Radar, backendKeys: ['Safety', 'Electrical'] },
  { slug: 'battery-ev', label: 'Battery/EV', icon: Battery, backendKeys: ['Electrical'] },
  { slug: 'drive', label: 'Drive', icon: Gauge, backendKeys: ['Drivetrain', 'Turbo'] },
  { slug: 'misc', label: 'Misc', icon: Package, backendKeys: ['Accessory'] },
];

export const BUYER_SUB_SYSTEM_BY_SLUG = Object.fromEntries(
  BUYER_SUB_SYSTEMS.map((s) => [s.slug, s])
);

export function resolveBuyerSubSystem(slugOrLabel) {
  const raw = String(slugOrLabel || '').trim();
  if (!raw) return null;
  const bySlug = BUYER_SUB_SYSTEM_BY_SLUG[raw.toLowerCase()];
  if (bySlug) return bySlug;
  const lower = raw.toLowerCase();
  return BUYER_SUB_SYSTEMS.find((s) => s.label.toLowerCase() === lower) || null;
}

export function backendKeysForSlug(slug) {
  const entry = resolveBuyerSubSystem(slug);
  return entry ? [...new Set(entry.backendKeys)] : [];
}
